import { AdminPermission } from '../../../services/commons/Me';
import { AdminPermissions, AdminPermissionsOnModule } from '../../../services/commons/Permissions/AdminPermissions';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';
import { PermissionType } from '../../../services/commons/Permissions/PermissionType';

export type UserPermissionsOnStatsModule = Pick<AdminPermissionsOnModule, 'canRead' | 'canExport'>;

export class StatsPermissions {
    public static STATS_CODE = 'Stats';

    public static Admin: UserPermissionsOnStatsModule = {};

    public static initializeStatsAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnStats = AdminPermissions.filter(perms, StatsPermissions.STATS_CODE);
        StatsPermissions.Admin = {
            ...AdminPermissions.toAdminModulePermissions(permsOnStats),
            canExport: AdminPermissions.has(PermissionType.Export, permsOnStats)
        }
        PermissionsAbilityHelper.logPermissions('Stats', StatsPermissions.Admin);
    };
}
